import React from "react";
import autoBind from "react-autobind";
import { markdownToHtml } from "../../utils/markupUtils";
import { getLocationValueString } from "../../utils/utils";
import PlayerLocationMap from "./PlayerLocationMap";
import withPlayerItemHoc from "./PlayerItemHoc";

import {
	Button
} from "react-bootstrap";

import Modal from "react-responsive-modal";
import DoneButton from "./DoneButton";

class PlayerLocation extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
		this.state = {
			showMap: false,
			mapValue: this.props.item.value
		};
	}

	onMapValueChange(value) {
		this.setState({ mapValue: value });
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.mapValue); }
	}

	showMap() {
		this.setState({ showMap: true, mapValue: this.props.item.value });
	}

	cancel() {
		this.setState({ showMap: false, mapValue: "" });
	}

	selectLocation() {
		if (this.props.onChange) { this.props.onChange(this.state.mapValue); }
		this.setState({ showMap: false });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.item.value !== this.props.item.value) {
			this.setState({ value: nextProps.item.value });
		}
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}


	renderReadOnly() {
		const { item, getLabelsReadOnly, getImage, getVideo, getPdf } = this.props;


		let value = getLocationValueString(item.value);

		const component =
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					{getLabelsReadOnly()}
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div dangerouslySetInnerHTML={markdownToHtml(value)} />
				</div>
			</div>;

		return component;
	}

	renderEditable() {

		const { item, getLabels, getImage, getVideo, getPdf, disabled } = this.props;


		let mapValue = getLocationValueString(this.state.mapValue);
		let value = getLocationValueString(item.value);

		let modal = <Modal
			open={this.state.showMap}
			onClose={this.cancel} classNames={{ modal: "custom-modal", overlay: "ambifi-web-player" }} closeButton>
			<div>
				<h4>Edit Location</h4>
				<div className="map-modal-body-container">
					<div className="map-container">
						<PlayerLocationMap value={this.state.mapValue} onChange={this.onMapValueChange} />
					</div>
					<div>
						<p>Current Location</p>
						<p dangerouslySetInnerHTML={{ __html: mapValue }} />
					</div>
				</div>
				<div className="modal-footer-container">
					<Button onClick={this.cancel} style={{ "margin-right": "10px" }}>Cancel</Button>
					<Button bsStyle="primary" onClick={this.selectLocation}>OK</Button>
				</div>
			</div>
		</Modal>;

		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					{getLabels()}
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div dangerouslySetInnerHTML={markdownToHtml(value)} />
					<div style={{ marginBottom: "12px" }}><Button onClick={disabled ? (e) => { e.stopPropagation(); } : this.showMap}>Edit Location</Button></div>
					<div>
						{!disabled && <DoneButton onSubmit={this.onSubmit} />}
					</div>
					{modal}
				</div>
			</div>
		);
	}
}

export default withPlayerItemHoc(PlayerLocation);